import LoaderInline from "./LoaderInline";

export default function FullPageLoader() {
  return (
    <div className="min-h-screen flex items-center justify-center">
      <LoaderInline />
    </div>
  );
}
